<script>
import InputTextarea from '@/components/atoms/inputlib/components/InputTextarea'
import FormValidation from '@/components/atoms/FormValidation'
import InputMap from '@/components/atoms/inputlib/components/InputMap'
import { mapGetters } from 'vuex'

export default {
    name: 'Step5',
    components: {
        InputTextarea,
        FormValidation,
        InputMap,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters(['smDevice']),
        addressValue: {
            get() {
                return this.address
            },
            set(address) {
                this.$emit('change', address)
            },
        },
        location() {
            return {
                latitude: this.address.latitude,
                longitude: this.address.longitude,
            }
        },
    },
    methods: {
        verifyStep() {
            this.$refs.form.formSubmit()
        },
        next() {
            this.$emit('next', 0)
        },
    },
}
</script>
<template lang="pug">
.row.no-gutters
    .col-12.col-md-4 
        input-map.border-radius-sm.overflow-hidden(:value="location" :height="smDevice ? '200px':'300px'")
    form-validation.col-12.col-md-8.pl-md-6(@submit="next" ref="form")
        input-textarea(
            v-model="addressValue.comment"
            validate="comment"
            :min-height="273"
            :placeholder="$t('details.placeholder.comment')"
            live resize) {{$t('details.comment')}}
</template>
